import React, { useState } from 'react';

const INITIAL_BOARD = {
  Backlog: ['Write Unit Tests'],
  'In Progress': ['API Integration', 'Refactor Auth Module'],
  Review: ['Fix Login Bug', 'Performance Optimization'],
  Done: ['Setup CI/CD', 'Design System Update', 'Update Docs'],
};

const EXPECTED_BOARD = {
  Backlog: ['Update Docs'],
  'In Progress': ['Write Unit Tests', 'Refactor Auth Module'],
  Review: ['API Integration', 'Performance Optimization'],
  Done: ['Setup CI/CD', 'Design System Update', 'Fix Login Bug'],
};

const COLUMNS = ['Backlog', 'In Progress', 'Review', 'Done'];

export default function C11_KanbanRearrange({ onComplete }) {
  const [board, setBoard] = useState(INITIAL_BOARD);
  const [dragging, setDragging] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const [verified, setVerified] = useState(false);

  const onDragStart = (card, fromCol) => setDragging({ card, fromCol });
  const onDragOver = (e, col) => { e.preventDefault(); setDragOver(col); };
  const onDrop = (e, toCol) => {
    e.preventDefault();
    if (!dragging || dragging.fromCol === toCol) { setDragging(null); setDragOver(null); return; }
    setBoard(prev => ({
      ...prev,
      [dragging.fromCol]: prev[dragging.fromCol].filter(c => c !== dragging.card),
      [toCol]: [...prev[toCol], dragging.card],
    }));
    setDragging(null);
    setDragOver(null);
  };

  const handleVerify = () => {
    setVerified(true);
    const details = {};
    let correctMoves = 0;
    const MOVES = [
      { card: 'API Integration', from: 'In Progress', to: 'Review' },
      { card: 'Write Unit Tests', from: 'Backlog', to: 'In Progress' },
      { card: 'Fix Login Bug', from: 'Review', to: 'Done' },
      { card: 'Update Docs', from: 'Done', to: 'Backlog' },
    ];
    MOVES.forEach(m => {
      const inExpected = board[m.to]?.includes(m.card);
      const notInFrom = !board[m.from]?.includes(m.card);
      const pass = inExpected && notInFrom;
      details[m.card] = { expected: `In "${m.to}"`, got: Object.entries(board).find(([, v]) => v.includes(m.card))?.[0] || '?', pass };
      if (pass) correctMoves++;
    });
    const pct = Math.round((correctMoves / MOVES.length) * 100);
    onComplete({ score: pct, details, passed: pct === 100 });
  };

  return (
    <div className="ab-challenge-ui">
      <p className="ab-hint">Drag cards between columns to complete the required moves.</p>
      <div className="ab-kanban-board">
        {COLUMNS.map(col => (
          <div key={col} className={`ab-kanban-col ${dragOver === col ? 'ab-kanban-col-over' : ''}`}
            onDragOver={e => onDragOver(e, col)} onDrop={e => onDrop(e, col)} onDragLeave={() => setDragOver(null)}>
            <div className="ab-kanban-col-header">
              <span>{col}</span>
              <span className="ab-col-count">{board[col].length}</span>
            </div>
            {board[col].map(card => (
              <div key={card}
                className={`ab-kanban-card ${dragging?.card === card ? 'ab-kanban-card-dragging' : ''}`}
                draggable={!verified}
                onDragStart={() => onDragStart(card, col)}
                onDragEnd={() => { setDragging(null); setDragOver(null); }}>
                {card}
              </div>
            ))}
            {board[col].length === 0 && <div className="ab-kanban-empty">Drop here</div>}
          </div>
        ))}
      </div>
      {!verified
        ? <button className="ab-action-btn" onClick={handleVerify}>Verify Board</button>
        : <div className="ab-submitted-badge">✓ Board Verified — Evaluating...</div>
      }
    </div>
  );
}
